import { useTheme } from "../contexts/ThemeContext";
import { Sun, Moon, MonitorSmartphone, Palette } from "lucide-react";
import PremiumIcon from "./ui/PremiumIcon";

/**
 * Appearance settings card — mounted on ProfilePage. Three-way toggle
 * (Light / Dark / Auto). Preference persists in localStorage via the
 * ThemeContext, and Auto reactively follows the OS scheme.
 */
export default function AppearanceCard() {
  const { mode, setMode } = useTheme();
  const options = [
    { key: "light", icon: Sun, label: "Claro" },
    { key: "dark",  icon: Moon, label: "Oscuro" },
    { key: "auto",  icon: MonitorSmartphone, label: "Automático" },
  ];
  return (
    <div className="card-base" data-testid="appearance-card">
      <div className="flex items-center gap-3 mb-4">
        <PremiumIcon icon={Palette} variant="gradient" tone="blue" size="md" />
        <div>
          <h3 className="font-heading font-semibold text-lg">Apariencia</h3>
          <p className="text-sm text-neutral-500">Elige cómo se ve RivoNes en tu dispositivo</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Tema de la aplicación">
        {options.map(({ key, icon: Icon, label }) => {
          const active = mode === key;
          return (
            <button
              key={key}
              role="radio"
              aria-checked={active}
              type="button"
              onClick={() => setMode(key)}
              className={`flex flex-col items-center justify-center gap-2 py-3 rounded-xl border transition-all active:scale-95 ${
                active
                  ? "border-terracotta bg-terracotta/5 ring-2 ring-terracotta/30 text-terracotta"
                  : "border-neutral-200 hover:border-neutral-300 text-neutral-600"
              }`}
              data-testid={`appearance-${key}`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.75} />
              <span className="text-xs font-medium">{label}</span>
            </button>
          );
        })}
      </div>
      <p className="text-xs text-neutral-500 mt-3">
        {mode === "auto"
          ? "Automático sigue la configuración de tu dispositivo."
          : "Tu preferencia se guardará entre sesiones."}
      </p>
    </div>
  );
}
